window.moment = require("moment")

import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'jquery-validation'

import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/position'

import 'jquery-ui/ui/widgets/mouse'
import 'jquery-ui/ui/widgets/accordion'
import 'jquery-ui/ui/widgets/autocomplete'
import 'jquery-ui/ui/widgets/button'
import 'jquery-ui/ui/widgets/checkboxradio'
import 'jquery-ui/ui/widgets/controlgroup'
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/widgets/dialog'
import 'jquery-ui/ui/widgets/draggable'
import 'jquery-ui/ui/widgets/droppable'
import 'jquery-ui/ui/widgets/menu'
import 'jquery-ui/ui/widgets/progressbar'
import 'jquery-ui/ui/widgets/resizable'
import 'jquery-ui/ui/widgets/selectable'
import 'jquery-ui/ui/widgets/selectmenu'
import 'jquery-ui/ui/widgets/slider'
import 'jquery-ui/ui/widgets/sortable'
import 'jquery-ui/ui/widgets/spinner'
import 'jquery-ui/ui/widgets/tabs'
import 'jquery-ui/ui/widgets/tooltip'

import InputMask from 'inputmask'
import 'inputmask/dist/jquery.inputmask'
window.Inputmask = Inputmask